if (!customElements.get('quickbuy-widget')) {
  customElements.define(
    'quickbuy-widget',
    class QuickbuyWidget extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {   
        const sizeSelect = this.querySelectorAll('[data-option-select]');
        const mainSelect = this.querySelector('[data-main-select]');
        this.addEventListener('change', (e) => {
          let options = [];
          sizeSelect.forEach(select => {
            options.push(select.value)
          });
          options = options.join('-');
          mainSelect.options.forEach(option => {
            option.innerText.trim() == options ? option.setAttribute('selected', 'selected') : option.removeAttribute('selected')
          })
        });
      }
    }
  );
}